<template>
  <div>
    <b-card>
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0">Claim Wizard</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4">
          <div class="form-group">
            <label class="form-control-label">Select Claim Document</label>
            <v-select
              class="vue-select"
              placeholder="Choose a Claim"
              :options="userClaimOptions"
              v-model="claim_id"
              :reduce="(option) => option.id"
              v-on:input="filterClaimListByClient"
            ></v-select>
          </div>
        </b-col>
        <b-col lg="4">
          <b-form inline class="pt-4 mt-3">
            <label
              class="form-control-label"
              for="inline-form-custom-select-pref"
              >Status</label
            >
            <p class="pl-3 text-green">{{ claimStatusStr }}</p>
          </b-form>
        </b-col>
        <b-col lg="4"> </b-col>
      </b-row>

      <b-card no-body>
        <b-tabs pills card v-model="tb_step">
          <b-tab title="Summary">
            <b-card-text>
              <Summary :claim_id="claim_id" />
            </b-card-text>
          </b-tab>
          <b-tab title="Documents" @click="refreshDocuments()">
            <b-card-text>
              <Document ref="docComponent" :claim_id="claim_id" />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import Summary from "@/components/Summary/Summary.vue";
import Document from "@/components/Document/Document.vue";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import mixins from "./../../mixins/common.js";
export default {
  components: {
    Summary,
    Document,
  },
  data() {
    return {
      userClaimOptions: [],
      claimData: [],
      claim_id: "",
    };
  },
  mixins: [mixins],
  methods: {
    ...mapActions("client", ["getUserClaims"]),
    refreshDocuments() {
      this.$refs.docComponent.refreshClaimDocs();
    },
    filterClientsClaimsOptions(options) {
      let arr = [];
      options.forEach((value, index) => {
        let obj = {
          label:
            value.fiscalYear +
            " | " +
            this.getMonthNameFormValue(value.fiscalMonth) +
            " " +
            value.fiscalDay +
            " " +
            "FYE" +
            " | " +
            this.ammendString(value.isAmendment),
          id: value.id,
        };
        arr.push(obj);
      });
      return arr;
    },
    filterClaimListByClient() {
      let claim_id = this.claim_id;

      let filtered = this.claimData.filter((claim) => {
        return claim.id == this.claim_id;
      });

      if (filtered[0]) {
        this.activeClaimData = filtered[0];
      } else {
        this.activeClaimData = [];
      }
    },
  },
  computed: {
    activeClaimData: {
      get() {
        return this.$store.state.activeClaimData;
      },
      set(val) {
        this.$store.state.activeClaimData = val;
      },
    },
    activeClaimStr() {
      return (
        this.activeClaimData.fiscalYear +
        " | " +
        this.getMonthNameFormValue(value.fiscalMonth) +
        " " +
        value.fiscalDay +
        " " +
        "FYE" +
        " | " +
        this.ammendString(value.isAmendment)
      );
    },

    claimStatusStr() {
      return this.activeClaimData.claimStatus
        ? this.claimStatusString(this.activeClaimData.claimStatus)
        : "";
    },
    tb_step: {
      get() {
        return this.$store.state.tb_step;
      },
      set(val) {
        this.$store.state.tb_step = val;
      },
    },
  },
  mounted() {
    const userdata = {};
    this.getUserClaims(userdata).then((data) => {
      if (data.data.errors) {
      } else {
        /* loadash filter array from year/month/date */
        let filtered = _.sortBy(data.data, function (dateObj) {
          return new Date(
            dateObj.fiscalYear +
              "/" +
              dateObj.fiscalMonth +
              "/" +
              dateObj.fiscalDay
          );
        });
        let sortedClaimArray = filtered.reverse();
        this.userClaimOptions =
          this.filterClientsClaimsOptions(sortedClaimArray);
        this.claimData = data.data;
        this.claim_id = sortedClaimArray[0].id;
        this.filterClaimListByClient();
      }
    });
  },
  created() {
    if (this.$route.query.tb_step) {
      this.tb_step = parseInt(this.$route.query.tb_step);
    }
  },
  watch: {
    tb_step: function (newVal, oldVal) {
      if (this.tb_step != this.$route.query.tb_step) {
        this.$router.replace({
          name: "claimwizard",
          query: { tb_step: this.tb_step },
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
